import ShipmentCalculator from './shipmentCalculator';

export default ShipmentCalculator;
